<a
	#popoverTrigger="mtxPopoverTrigger"
	[mtxPopoverTriggerFor]="notificationsPopover"
	mtxPopoverTriggerOn="click"
	class="cursor-pointer"
	(click)="getVisibleElements(5)"
>
	<mat-icon [matBadge]="unreadCount$ | async" matBadgeColor="warn" class="header-button">
		notifications
	</mat-icon>
</a>

<mtx-popover #notificationsPopover="mtxPopover" [closeOnPanelClick]="false">
	<div class="viewport background-white" #notifications>
		<mat-selection-list [multiple]="false" (wheel)="getVisibleElements(5)" class="selection-list">
			<mat-list-option class="empty"></mat-list-option>
			<mat-list-option
				*ngIf="(notificationsStore.notifications$ | async)?.length === 0"
				disabled="true"
				class="background-white"
			>
				<span matLine class="font-size-12">No Notifications</span>
			</mat-list-option>
			<mat-list-option
				#notification
				*ngFor="let notification of notificationsStore.notifications$ | async"
				[attr.data-notification]="serializeNotification(notification)"
				[value]="notification.id"
				(click)="notificationClicked(notification)"
			>
				<span matLine class="font-size-12">{{ notification.message }}</span>
				<span matLine class="font-size-8">{{ notification.createdAt | date: 'short' }}</span>
			</mat-list-option>
		</mat-selection-list>
	</div>
</mtx-popover>
